import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { TransferDetails } from '@root/features/wallet/transfer/ui/desktop/transfer-details'
import { useTranslation } from '@root/shared/localization'

import { walletsManagerModelAtom } from '../../atoms'

import { WalletDetailsSection } from './wallet-details-section'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const WalletDetailsTransfer: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()
  const [model] = useAtom(walletsManagerModelAtom)
  const clearSelectedWallet = useAction(model.clearSelectedWallet)

  return (
    <Root title={t('transfer')} onClose={clearSelectedWallet}>
      <TransferDetails wallet={wallet} />
    </Root>
  )
}

const Root = styled(WalletDetailsSection)`
  display: grid;
  height: 100%;
`
